/* eslint-disable max-len */
const React = require('react');

const HomeTitleImage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="83" height="59" viewBox="0 0 83 59">
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" stroke="#009EE3" strokeWidth="2.182" d="M26.454 13h28.092c.803 0 1.454.651 1.454 1.454V28.5C56 37.06 49.06 44 40.5 44 31.94 44 25 37.06 25 28.5V14.454c0-.803.651-1.454 1.454-1.454z" />
      <path fill="#009EE3" fillRule="nonzero" d="M47 4v10h2V4zM56 18H26v2h30z" />
      <g fill="#009EE3" fillRule="nonzero">
        <path d="M35.5 35l1.229-1.698c.87.924 2.23 1.736 3.988 1.736 1.815 0 2.533-.887 2.533-1.717 0-1.132-1.342-1.472-2.873-1.868-2.06-.51-4.48-1.113-4.48-3.774 0-2.075 1.834-3.679 4.594-3.679 1.966 0 3.553.623 4.725 1.755l-1.266 1.641c-.983-.98-2.325-1.434-3.648-1.434-1.305 0-2.137.623-2.137 1.566 0 .981 1.286 1.302 2.78 1.68 2.079.528 4.555 1.17 4.555 3.905 0 2.095-1.474 3.887-4.877 3.887-2.325 0-4.008-.811-5.123-2z" />
        <path d="M41.5 25v-3h-2v3zM41.5 39v-3h-2v3z" />
      </g>
      <path fill="#009EE3" fillRule="nonzero" d="M32 4v10h2V4z" />
      <path stroke="#009EE3" strokeWidth="2" d="M41 44v2a7 7 0 0 0 7 7h18" />
    </g>
  </svg>
);

module.exports = HomeTitleImage;
